import * as React from "react";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Presets from "../presets/Presets";
import Design from "../design/Design";
import Overview from "../overview/Overview";
import BuyNow from "../buynow/BuyNow";
import { BlueButton } from "../../molecules/BlueButton";
import { CartContext } from "../../contex/CartProvider";
import { Typography } from "@mui/material";

function CustomMobileStepper() {
  const { cart } = React.useContext(CartContext);
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = 4;
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
      {activeStep === maxSteps ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1, ml: 2 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <BlueButton onClick={handleReset}>Reset</BlueButton>
          </Box>
        </React.Fragment>
      ) : (
        <>
          <div>
            {activeStep === 0 && <Presets />}
            {activeStep === 1 && <Design />}
            {activeStep === 2 && <Overview />}
            {activeStep === 3 && <BuyNow />}
          </div>

          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
              <BlueButton
                onClick={handleNext}
                disabled={activeStep === 1 && cart.length === 0}
              >
                {activeStep === 4 - 1 ? "Finish" : "Next"}
              </BlueButton>
            }
            backButton={
              <BlueButton
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </BlueButton>
            }
          />
        </>
      )}
    </Box>
  );
}

export default CustomMobileStepper;
